var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"formimmutablefield"},[_c('span',{staticClass:"formimmutablefield-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"formimmutablefield-text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }